import React from 'react';

import { ConfirmModal } from '~/components/ConfirmModal';

interface StaleDraftsConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// Shown before a live save that would invalidate saved drafts of the same configuration, so the
// editor can back out instead of losing them silently.
const StaleDraftsConfirmModal: React.FC<StaleDraftsConfirmModalProps> = ({ isOpen, onClose, onConfirm }) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Saved drafts will become unavailable"
    contentText="This configuration has saved drafts based on its current version. Saving now will make them unavailable, and they will no longer be listed. Do you want to continue?"
    primaryButtonName="Save"
    secondaryButtonName="Cancel"
    onClose={onClose}
    onPrimaryBtnClick={onConfirm}
  />
);

export default StaleDraftsConfirmModal;
